import { render, staticRenderFns } from "./Form1.vue?vue&type=template&id=7bb7097e&scoped=true"
import script from "./Form1.vue?vue&type=script&lang=ts"
export * from "./Form1.vue?vue&type=script&lang=ts"
import style0 from "./Form1.vue?vue&type=style&index=0&id=7bb7097e&prod&scoped=true&lang=css"
import style1 from "./Form1.vue?vue&type=style&index=1&id=7bb7097e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb7097e",
  null
  
)

export default component.exports